var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-modal',{ref:"modal",attrs:{"close-on-backdrop-click":""}},[_c('nexultra-l-marketing-campaign',{attrs:{"unit-price":_vm.unitPrice,"threshold-amount":_vm.thresholdAmount}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }